<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useAdStore } from "@/stores/AdStore.js";
  import { useUserStore } from "@/stores/UserStore.js";
  import { useIntersectionObserver } from '@vueuse/core';

  import BannerAd from '@/components/BannerAd.vue';

  import useAdConfigurationGlobals from '@/composables/useAdConfigurationGlobals';
  import { useMediaQuery } from '@/composables/useMediaQuery';

  const { $FOOTER_AD } = useAdConfigurationGlobals();   

  const props = defineProps({
    refreshOnClick: {
      type: Boolean,
      default: false
    },
    refreshOnScroll: {
      type: Boolean,
      default: false
    },
    scrollTarget: {
      type: Object,
      default: null
    },
    mobileOnly: {
      type: Boolean,
      default: true
    }
  });

  const adStore = useAdStore();
  const userStore = useUserStore();

  const isDesktop = useMediaQuery('(min-width: 800px)');

  const id = ref(null);

  const isRequiredDeviceSize = computed(() => !props.mobileOnly ? true : !isDesktop.value);
  const showFooterAd = computed(() => $FOOTER_AD && isRequiredDeviceSize.value && (userStore.showAds || userStore.memberLevel < 46));

  function setFooterAdAttribute() {
    const body = document.documentElement;
    body.dataset.footerAd = true;
  }

  setFooterAdAttribute();

  const initScrollObserver = () => {
    if (!props.scrollTarget) return;
    
    const thresholdCount = 20;
    const threshold = Array.from({ length: thresholdCount }).map((_, i) => i / thresholdCount);
    const options = { rootMargin: '0px', threshold };

    useIntersectionObserver(
      props.scrollTarget,
      () => {
        adStore.refreshAd(id.value);
      },
      options
    )     
  }

  const initClickListener = () => {
    document.addEventListener('click', () => {
      adStore.refreshAd(id.value);
    })
  }

  onMounted(() => {
    if (props.refreshOnScroll) {
      initScrollObserver();
    }
    if (props.refreshOnClick) {
      initClickListener();
    }
  })
</script>

<template>
  <div
    v-if="showFooterAd" 
    class="jwx-footer-banner-ad-container"
  >
    <BannerAd v-model:id="id" type="header" />
  </div>
</template>